
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6d35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6d35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("79tbc", function(module, exports) {

var $67wrA = parcelRequire("67wrA");

var $eON6H = parcelRequire("eON6H");

var $chbRA = parcelRequire("chbRA");

var $kHnz7 = parcelRequire("kHnz7");

var $4MScu = parcelRequire("4MScu");

var $4eM2B = parcelRequire("4eM2B");

var $gngdn = parcelRequire("gngdn");
parcelRequire("bJHsY");
parcelRequire("f2hMu");
parcelRequire("gYC2S");
const $5350022702bf54a6$var$TODAY = $gngdn().format("YYYY-MM-DD");
const $5350022702bf54a6$var$INITIAL_YEAR = $gngdn().format("YYYY");
const $5350022702bf54a6$var$INITIAL_MONTH = $gngdn().format("M");
const $5350022702bf54a6$var$OFF_SEASON_SLOTS = JSON.parse(document.getElementById("off-season-data").dataset.slots);
let $5350022702bf54a6$var$QUICK_RELEASE_DATA = null;
let $5350022702bf54a6$var$NUMBER_OF_PASSENGERS = 1;
let $5350022702bf54a6$var$LANGUAGE = "fr";
let $5350022702bf54a6$var$CALENDAR_ELEMENT = null;
let $5350022702bf54a6$var$selectedMonth = $gngdn(new Date($5350022702bf54a6$var$INITIAL_YEAR, $5350022702bf54a6$var$INITIAL_MONTH - 1, 1));
let $5350022702bf54a6$var$currentMonthDays;
let $5350022702bf54a6$var$previousMonthDays;
let $5350022702bf54a6$var$nextMonthDays;
const $5350022702bf54a6$var$AREAS = {
    yUvqaIOWo75OYQoTJG64: "FB",
    eN48VsrzsBfO5klfhV3m: "CH"
};
const $5350022702bf54a6$var$updateQuickReleaseData = ()=>{
    $5350022702bf54a6$var$CALENDAR_ELEMENT.classList.add("loading");
    $eON6H.fetchData().then((quickReleaseData)=>{
        $5350022702bf54a6$var$QUICK_RELEASE_DATA = quickReleaseData;
        $5350022702bf54a6$var$updateCalendar($5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentYear, $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentMonth);
        $5350022702bf54a6$var$CALENDAR_ELEMENT.classList.remove("loading");
    });
};
const $5350022702bf54a6$var$buildCalendar = (elementID)=>{
    if (elementID) {
        const language = document.getElementsByTagName("html")[0].attributes.lang.value;
        language !== "fr" && ($5350022702bf54a6$var$LANGUAGE = language);
        $gngdn.locale(language);
        let numberOfPassengers = 1;
        let currentYear = $5350022702bf54a6$var$INITIAL_YEAR;
        let currentMonth = $5350022702bf54a6$var$INITIAL_MONTH;
        if ($4eM2B.existingReservation !== false) {
            numberOfPassengers = $4eM2B.reservation.numberOfPassengers;
            $5350022702bf54a6$var$updateNumberOfPassengers(numberOfPassengers);
            currentYear = $4eM2B.reservation.year;
            currentMonth = $4eM2B.reservation.month;
            $5350022702bf54a6$var$selectedMonth = $gngdn(new Date(currentYear, currentMonth - 1, 1));
        }
        document.getElementById(elementID).innerHTML = `
            <input type="hidden" value="` + numberOfPassengers + `" id="number-of-passengers-value"/>
            <div class="calendar-month loading" id="calendar-month" data-current-month="` + currentMonth + `" data-current-year="` + currentYear + `">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
              <div class="calendar-month-header">
                <div id="selected-month" class="calendar-month-header-selected-month" ></div>
                <div class="calendar-month-header-selectors">
                  <span id="previous-month-selector"><</span>
                  <span id="present-month-selector">` + $67wrA.TODAY_STRING + `</span>
                  <span id="next-month-selector">></span>
                </div>
              </div>

              <ol id="days-of-week" class="day-of-week"/></ol>
              <ol id="calendar-days" class="days-grid"></ol>

              <div class="calendar-available-slots" id="calendar-available-slots">
                <div id="close-available-slots"></div>
                <div id="slots-selected-date"></div>
                <div id="slots-wrapper"></div>
              </div>
            </div>

            <div class="legends">
                <div class="legend-row">
                    <div class="legend today" id="legend-today"><span class="color"></span>` + $67wrA.LEGENDS.today + `</div>
                    <div class="legend available" id="legend-available"><span class="color"></span>` + $67wrA.LEGENDS.available + `</div>
                    <div class="legend full-closed" id="legend-full-closed"><span class="color"></span>` + $67wrA.LEGENDS.fullClosed + `</div>
                    <div class="legend off-season" id="legend-off-season"><span class="color"></span>` + $67wrA.LEGENDS.offSeason + `</div>
                    <div class="area ch">
                        <span class="picto">VM</span>
                        <div class="name-description">
                            <span>` + $67wrA.SLOTS.flightType.mountainFlight + `</span>
                            <span>(` + $67wrA.SLOTS.flightType.mountainFlightDescription + `)</span>
                        </div>
                    </div>
                    <div class="area fb">
                        <span class="picto">VS</span>
                        <div class="name-description">
                            <span>` + $67wrA.SLOTS.flightType.lowlandFlight + `</span>
                            <span>(` + $67wrA.SLOTS.flightType.lowlandFlightDescription + `)</span>
                        </div>
                    </div>
                </div>
            </div>
        `;
        $5350022702bf54a6$var$CALENDAR_ELEMENT = document.getElementById("calendar-month");
        const daysOfWeekElement = document.getElementById("days-of-week");
        $67wrA.WEEKDAYS.forEach((weekday)=>{
            const weekDayElement = document.createElement("li");
            daysOfWeekElement.appendChild(weekDayElement);
            weekDayElement.innerText = weekday;
        });
        $5350022702bf54a6$var$initMonthSelectors();
        $5350022702bf54a6$var$initSlotsModalClose();
        $5350022702bf54a6$var$updateQuickReleaseData();
        if ($4eM2B.existingReservation) $5350022702bf54a6$var$selectSlot($4eM2B.reservation.flightData, $gngdn($4eM2B.reservation.datetime).format("H") < 15 ? "mountainFlight" : "lowlandFlight");
        return $5350022702bf54a6$var$CALENDAR_ELEMENT;
    } else console.error("Please provide HTML element ID attribute value to build calendar");
};
const $5350022702bf54a6$var$updateCalendar = (year = $5350022702bf54a6$var$INITIAL_YEAR, month = $5350022702bf54a6$var$INITIAL_MONTH)=>{
    const calendarDaysElements = document.getElementById("calendar-days");
    document.getElementById("selected-month").innerText = $gngdn(new Date(year, month - 1)).format("MMMM YYYY");
    $5350022702bf54a6$var$removeAllDaysElements(calendarDaysElements);
    $5350022702bf54a6$var$currentMonthDays = $5350022702bf54a6$var$createDaysForCurrentMonth(year, month, $gngdn(`${year}-${month}-01`).daysInMonth());
    $5350022702bf54a6$var$previousMonthDays = $5350022702bf54a6$var$createDaysForPreviousMonth(year, month);
    $5350022702bf54a6$var$nextMonthDays = $5350022702bf54a6$var$createDaysForNextMonth(year, month);
    const days = [
        ...$5350022702bf54a6$var$previousMonthDays,
        ...$5350022702bf54a6$var$currentMonthDays,
        ...$5350022702bf54a6$var$nextMonthDays
    ];
    const currentDate = $gngdn();
    const hoursBeforeBooking = JSON.parse(document.getElementById("hours-before-booking").dataset.hoursBeforeBooking);
    const minimalBookingDate = currentDate.add(hoursBeforeBooking, "hour");
    days.forEach((day)=>{
        $5350022702bf54a6$var$appendDay(day, calendarDaysElements, minimalBookingDate);
    });
    $5350022702bf54a6$var$CALENDAR_ELEMENT.classList.remove("loading");
};
const $5350022702bf54a6$var$createDaysForCurrentMonth = (year, month)=>{
    return [
        ...Array($5350022702bf54a6$var$getNumberOfDaysInMonth(year, month))
    ].map((day, index)=>{
        return {
            date: $gngdn(`${year}-${month}-${index + 1}`).format("YYYY-MM-DD"),
            dayOfMonth: index + 1,
            isCurrentMonth: true
        };
    });
};
const $5350022702bf54a6$var$createDaysForPreviousMonth = (year, month)=>{
    let firstDayOfTheMonthWeekday = $5350022702bf54a6$var$getWeekDay($5350022702bf54a6$var$currentMonthDays[0].date);
    const previousMonth = $gngdn(`${year}-${month}-01`).subtract(1, "month");
    const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday;
    const previousMonthLastMondayDayOfMonth = $gngdn($5350022702bf54a6$var$currentMonthDays[0].date).subtract(visibleNumberOfDaysFromPreviousMonth, "day").date();
    return [
        ...Array(visibleNumberOfDaysFromPreviousMonth)
    ].map((day, index)=>{
        return {
            date: $gngdn(`${previousMonth.year()}-${previousMonth.month() + 1}-${previousMonthLastMondayDayOfMonth + index}`).format("YYYY-MM-DD"),
            dayOfMonth: previousMonthLastMondayDayOfMonth + index,
            isCurrentMonth: false
        };
    });
};
const $5350022702bf54a6$var$createDaysForNextMonth = (year, month)=>{
    let lastDayOfTheMonthWeekday = $5350022702bf54a6$var$getWeekDay(`${year}-${month}-${$5350022702bf54a6$var$currentMonthDays.length}`);
    const nextMonth = $gngdn(`${year}-${month}-01`).add(1, "month");
    const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday ? 7 - lastDayOfTheMonthWeekday : 7 - lastDayOfTheMonthWeekday;
    return [
        ...Array(visibleNumberOfDaysFromNextMonth)
    ].map((day, index)=>{
        return {
            date: $gngdn(`${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`).format("YYYY-MM-DD"),
            dayOfMonth: index + 1,
            isCurrentMonth: false
        };
    });
};
const $5350022702bf54a6$var$appendDay = (day, calendarDaysElements, minimalBookingDate)=>{
    let dayData = [];
    $5350022702bf54a6$var$QUICK_RELEASE_DATA.forEach((data)=>{
        if (data.flightDate === day.date) dayData.push(data);
    });
    const dayElement = document.createElement("li");
    const dayElementClassList = dayElement.classList;
    dayElementClassList.add("calendar-day");
    const dayOfMonthElement = document.createElement("span");
    dayOfMonthElement.innerText = day.dayOfMonth;
    dayElement.appendChild(dayOfMonthElement);
    calendarDaysElements.appendChild(dayElement);
    $5350022702bf54a6$var$OFF_SEASON_SLOTS.forEach((slot)=>{
        if ($gngdn(day.date).isBetween(slot.startDate, slot.endDate, "day", "[]")) dayElementClassList.add("calendar-day--off-season");
    });
    if (!dayElementClassList.contains("calendar-day--off-season")) {
        if (!day.isCurrentMonth) dayElementClassList.add("calendar-day--not-current");
        else if ($gngdn(day.date).isBefore($5350022702bf54a6$var$TODAY)) dayElementClassList.add("calendar-day--past");
        else if (day.date === $5350022702bf54a6$var$TODAY) dayElementClassList.add("calendar-day--today");
        else if (dayData.length) {
            let isAvailable = false;
            const regionsContainer = document.createElement("div");
            regionsContainer.classList.add("region-container");
            dayElement.appendChild(regionsContainer);
            const numberOfPassengers = parseInt(document.getElementById("booking-form-numberOfPassengers").value);
            dayData.forEach((data)=>{
                const flightDate = $gngdn(data.flightDate + " " + data.flightHour, "YYYY-MM-DD HH:mm");
                if (flightDate.isAfter(minimalBookingDate) && data.freeCapacity - data.toConfirmPassengers >= numberOfPassengers) {
                    $5350022702bf54a6$var$appendRegionToDay(regionsContainer, data);
                    isAvailable = true;
                    return false;
                }
            });
            if (isAvailable) {
                dayElementClassList.add("calendar-day--available");
                dayElement.addEventListener("click", function() {
                    $5350022702bf54a6$var$showAvailableSlots(dayData, minimalBookingDate);
                });
            }
        }
    }
};
const $5350022702bf54a6$var$appendRegionToDay = (regionsContainer, data)=>{
    if (!regionsContainer.querySelector(".region-" + $5350022702bf54a6$var$AREAS[data.region])) {
        const flightHour = parseInt(data.flightHour.split(":")[0]);
        let flightType = "VS";
        if (flightHour < 15) flightType = "VM";
        const regionElement = document.createElement("div");
        regionElement.innerHTML = flightType;
        regionElement.classList.add("region-item");
        regionElement.classList.add("region-" + flightType);
        regionsContainer.appendChild(regionElement);
    }
};
const $5350022702bf54a6$var$showAvailableSlots = (dayData, minimalBookingDate)=>{
    const slotsWrapperElement = $5350022702bf54a6$var$CALENDAR_ELEMENT.querySelector("#slots-wrapper");
    while(slotsWrapperElement.firstChild)slotsWrapperElement.removeChild(slotsWrapperElement.firstChild);
    const slotsSelectedDateElement = $5350022702bf54a6$var$CALENDAR_ELEMENT.querySelector("#slots-selected-date");
    slotsSelectedDateElement.innerHTML = "<span>" + $gngdn(dayData[0].flightDate).format("DD MMMM YYYY") + "</span>";
    $5350022702bf54a6$var$NUMBER_OF_PASSENGERS = document.getElementById("booking-form-numberOfPassengers").value;
    dayData.forEach((data)=>{
        const flightDate = $gngdn(data.flightDate + " " + data.flightHour, "YYYY-MM-DD HH:mm");
        if (flightDate.isAfter(minimalBookingDate) && data.freeCapacity - data.toConfirmPassengers >= $5350022702bf54a6$var$NUMBER_OF_PASSENGERS) {
            const slotElement = document.createElement("div");
            const remainingPlaceString = data.freeCapacity - data.toConfirmPassengers > 1 ? data.freeCapacity - data.toConfirmPassengers + " " + $67wrA.SLOTS.remainingPlaces : data.freeCapacity - data.toConfirmPassengers + " " + $67wrA.SLOTS.remainingPlace;
            const flightHour = parseInt(data.flightHour.split(":")[0]);
            let flightType = "";
            let flightTypeTranslation = "";
            if (flightHour < 15) {
                flightTypeTranslation = $67wrA.SLOTS.flightType.mountainFlight + " (" + $67wrA.SLOTS.flightType.mountainFlightDescription + ")";
                flightType = "mountainFlight";
            } else {
                flightTypeTranslation = $67wrA.SLOTS.flightType.lowlandFlight + " (" + $67wrA.SLOTS.flightType.lowlandFlightDescription + ")";
                flightType = "lowlandFlight";
            }
            slotElement.classList.add("slot-item");
            slotElement.innerHTML = `
                <div class="location">` + data.regionName + `</div>
                <div class="flight-hour">` + data.flightHour + `</div>
                <div class="flight-type">` + flightTypeTranslation + `</div>
                <div class="slot-free-capacity">` + remainingPlaceString + `</div>
            `;
            const slotBookingButtonWrapper = document.createElement("div");
            slotBookingButtonWrapper.classList.add("slot-booking-button-wrapper");
            const slotBookingButton = document.createElement("div");
            slotBookingButton.classList.add("btn");
            slotBookingButton.classList.add("btn-primary");
            slotBookingButton.innerHTML = $67wrA.SLOTS.book;
            slotBookingButton.addEventListener("click", ()=>{
                $5350022702bf54a6$var$selectSlot(data, flightType);
            });
            slotBookingButtonWrapper.appendChild(slotBookingButton);
            slotElement.appendChild(slotBookingButtonWrapper);
            slotsWrapperElement.appendChild(slotElement);
        }
    });
    document.getElementById("calendar-available-slots").classList.add("visible");
};
const $5350022702bf54a6$var$selectSlot = (data, flightType)=>{
    const flightDateInput = document.getElementById("booking-form-flightDate");
    const flightHourInput = document.getElementById("booking-form-flightHour");
    const flightTypeInput = document.getElementById("booking-form-flightType");
    const flightDataInput = document.getElementById("booking-form-flightData");
    flightDateInput.value = $gngdn(data.flightDate).format("DD MMMM YYYY");
    flightHourInput.value = data.flightHour;
    flightTypeInput.value = flightType === "mountainFlight" ? $67wrA.SLOTS.flightType.mountainFlight : $67wrA.SLOTS.flightType.lowlandFlight;
    flightDataInput.value = JSON.stringify(data);
    if ($4eM2B.existingReservation) $chbRA.updatePassengersInformationsField($4eM2B.reservation.numberOfPassengers * 3);
    $4MScu.mountBookingBasketIfNeeded();
    $kHnz7.updateOrderSummaryTable(data.region, flightType);
    const numberOfPassengers = $4eM2B.existingReservation ? $4eM2B.reservation.numberOfPassengers : document.getElementById("booking-form-numberOfPassengers").value;
    const maximumPassengers = parseInt(document.getElementById("maximum-passengers").dataset.maximumPassengers);
    const freeCapacity = data.freeCapacity - data.toConfirmPassengers;
    if (numberOfPassengers < maximumPassengers && numberOfPassengers < freeCapacity) $chbRA.createAddPassengerButton();
    else $chbRA.removeAddPassengerButton();
    const bookingFormElement = document.querySelector(".tc-website-bookingform");
    if (!bookingFormElement.classList.contains("visible")) {
        if ($4eM2B.existingReservation) $chbRA.fillSubscriberInformation();
        $chbRA.updatePassengersInformationsField(3 * numberOfPassengers);
        bookingFormElement.classList.add("visible");
    }
    document.getElementById("calendar-available-slots").classList.remove("visible");
    const orderSummaryAlert = document.querySelector(".order-summary-alert");
    const orderSummaryTable = document.querySelector(".order-summary-table");
    if (orderSummaryAlert) orderSummaryAlert.classList.remove("visible");
    if (orderSummaryTable) orderSummaryTable.classList.remove("hidden");
    bookingFormElement.scrollIntoView();
};
const $5350022702bf54a6$var$initMonthSelectors = ()=>{
    $5350022702bf54a6$var$CALENDAR_ELEMENT.querySelector("#previous-month-selector").addEventListener("click", function() {
        $5350022702bf54a6$var$selectedMonth = $gngdn($5350022702bf54a6$var$selectedMonth).subtract(1, "month");
        $5350022702bf54a6$var$updateCalendar($5350022702bf54a6$var$selectedMonth.format("YYYY"), $5350022702bf54a6$var$selectedMonth.format("M"));
        $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentMonth = $5350022702bf54a6$var$selectedMonth.format("M");
        $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentYear = $5350022702bf54a6$var$selectedMonth.format("YYYY");
    });
    $5350022702bf54a6$var$CALENDAR_ELEMENT.querySelector("#present-month-selector").addEventListener("click", function() {
        $5350022702bf54a6$var$selectedMonth = $gngdn(new Date($5350022702bf54a6$var$INITIAL_YEAR, $5350022702bf54a6$var$INITIAL_MONTH - 1, 1));
        $5350022702bf54a6$var$updateCalendar($5350022702bf54a6$var$selectedMonth.format("YYYY"), $5350022702bf54a6$var$selectedMonth.format("M"));
        $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentMonth = $5350022702bf54a6$var$selectedMonth.format("M");
        $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentYear = $5350022702bf54a6$var$selectedMonth.format("YYYY");
    });
    $5350022702bf54a6$var$CALENDAR_ELEMENT.querySelector("#next-month-selector").addEventListener("click", function() {
        $5350022702bf54a6$var$selectedMonth = $gngdn($5350022702bf54a6$var$selectedMonth).add(1, "month");
        $5350022702bf54a6$var$updateCalendar($5350022702bf54a6$var$selectedMonth.format("YYYY"), $5350022702bf54a6$var$selectedMonth.format("M"));
        $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentMonth = $5350022702bf54a6$var$selectedMonth.format("M");
        $5350022702bf54a6$var$CALENDAR_ELEMENT.dataset.currentYear = $5350022702bf54a6$var$selectedMonth.format("YYYY");
    });
};
const $5350022702bf54a6$var$initSlotsModalClose = ()=>{
    document.getElementById("close-available-slots").addEventListener("click", function() {
        document.getElementById("calendar-available-slots").classList.remove("visible");
    });
};
const $5350022702bf54a6$var$getNumberOfDaysInMonth = (year, month)=>{
    return $gngdn(`${year}-${month}-01`).daysInMonth();
};
const $5350022702bf54a6$var$getWeekDay = (date)=>{
    const jsDay = $gngdn(date).day();
    return (jsDay + 6) % 7;
};
const $5350022702bf54a6$var$removeAllDaysElements = (calendarDaysElements)=>{
    let first = calendarDaysElements.firstElementChild;
    while(first){
        first.remove();
        first = calendarDaysElements.firstElementChild;
    }
};
const $5350022702bf54a6$var$updateNumberOfPassengers = (numberOfPassengers)=>{
    $5350022702bf54a6$var$NUMBER_OF_PASSENGERS = numberOfPassengers;
};
module.exports = {
    updateQuickReleaseData: $5350022702bf54a6$var$updateQuickReleaseData,
    buildCalendar: $5350022702bf54a6$var$buildCalendar,
    updateCalendar: $5350022702bf54a6$var$updateCalendar,
    initMonthSelectors: $5350022702bf54a6$var$initMonthSelectors,
    updateNumberOfPassengers: $5350022702bf54a6$var$updateNumberOfPassengers,
    selectedMonth: $5350022702bf54a6$var$selectedMonth
};

});
parcelRegister("67wrA", function(module, exports) {
const $474c9034caa9e90d$var$language = document.getElementsByTagName("html")[0].attributes.lang.value;
const $474c9034caa9e90d$var$maximumPassengers = document.getElementById("maximum-passengers").dataset.maximumPassengers;
const $474c9034caa9e90d$var$translations = {
    en: {
        TODAY_STRING: "Today",
        PLEASE_CHOOSE: "Please choose",
        WEEKDAYS: [
            "MO",
            "TU",
            "WE",
            "TH",
            "FR",
            "SA",
            "SU"
        ],
        LEGENDS: {
            today: "Today",
            fullClosed: "Full / Closed",
            available: "Available",
            offSeason: "Off season"
        },
        PASSENGERS: {
            modalTitle: "Number of passengers",
            modalText: `In order to provide you with our flight availability based on the number of passengers, please let us know the number of passengers who will be participating in this flight.`,
            save: "Save",
            alert: {
                heading: "Nombre incorrect",
                content: `The number of passengers must be between 1 and ` + $474c9034caa9e90d$var$maximumPassengers + `.`,
                complement: `If you wish to reserve more than ` + $474c9034caa9e90d$var$maximumPassengers + ` seats, you can create several reservations.`
            }
        },
        SLOTS: {
            flightType: {
                mountainFlight: "Morning Flight",
                mountainFlightDescription: "mountain",
                lowlandFlight: "Evening Flight",
                lowlandFlightDescription: "Swiss plateau"
            },
            book: "Book",
            remainingPlaces: "places",
            remainingPlace: "place"
        },
        DISCOUNT_VOUCHER: {
            label: "Discount voucher",
            placeholder: "Voucher no.",
            remainingAmount: `The remaining amount on your voucher will be %s.`
        },
        ORDER_SUMMARY: {
            title: "Your order summary",
            alert: `Please select a flight from the calendar.`,
            adultFlight: `Adult passenger flight`,
            childFlight: `Child passenger flight`,
            promoCodeDiscount: "Promo code discount"
        },
        PROMO_CODE: {
            label: "Promo code",
            placeholder: "PROMO CODE",
            verifying: "Checking\u2026",
            applied: "Promo applied.",
            invalid: "This promo code is not valid.",
            networkError: "Unable to verify the code. Please try again.",
            fapdeNeedChild: "This promo code requires at least one child passenger.",
            fapdeNeedAdult: "This promo code requires at least one adult passenger.",
            inactive: "This promo code exists but is not activated yet."
        }
    },
    fr: {
        TODAY_STRING: "Aujourd'hui",
        PLEASE_CHOOSE: "Veuillez choisir",
        WEEKDAYS: [
            "LU",
            "MA",
            "ME",
            "JE",
            "VE",
            "SA",
            "DI"
        ],
        LEGENDS: {
            today: `Aujourd'hui`,
            fullClosed: "Complet / Ferm\xe9",
            available: "Disponible",
            offSeason: "Hors saison"
        },
        PASSENGERS: {
            modalTitle: "Nombre de passagers",
            modalText: `Afin de vous fournir les disponibilit\xe9s de nos vols en fonction du nombre de passagers, veuillez nous indiquer le nombre de passagers qui participeront \xe0 ce vol.`,
            save: "Enregistrer",
            alert: {
                heading: "Nombre incorrect",
                content: `Le nombre de passagers doit \xeatre compris entre 1 et ` + $474c9034caa9e90d$var$maximumPassengers + `.`,
                complement: `Si vous souhaitez r\xe9server plus de ` + $474c9034caa9e90d$var$maximumPassengers + ` places, vous pouvez cr\xe9er plusieurs r\xe9servations.`
            }
        },
        SLOTS: {
            flightType: {
                mountainFlight: "Vol du Matin",
                mountainFlightDescription: "montagne",
                lowlandFlight: "Vol du Soir",
                lowlandFlightDescription: "plateau suisse"
            },
            book: "R\xe9server",
            remainingPlaces: "places",
            remainingPlace: "place"
        },
        DISCOUNT_VOUCHER: {
            label: "Bon de r\xe9duction",
            placeholder: "N\xb0 de bon",
            remainingAmount: `Le montant restant sur votre bon sera de %s.`
        },
        ORDER_SUMMARY: {
            title: "R\xe9sum\xe9 de votre commande",
            alert: `Veuillez s\xe9lectionner un vol \xe0 partir du calendrier.`,
            adultFlight: `Vol passager adulte`,
            childFlight: `Vol passager enfant`,
            promoCodeDiscount: "Remise code promo"
        },
        PROMO_CODE: {
            label: "Code promo",
            placeholder: "CODE PROMO",
            verifying: "V\xe9rification\u2026",
            applied: "Code promo appliqu\xe9.",
            invalid: "Ce code promo n\u2019est pas valable.",
            networkError: "Impossible de v\xe9rifier le code. R\xe9essayez.",
            fapdeNeedChild: "Ce code promo n\xe9cessite au moins un passager enfant.",
            fapdeNeedAdult: "Ce code promo n\xe9cessite au moins un passager adulte.",
            inactive: "Ce code promo existe mais n\u2019est pas encore activ\xe9."
        }
    },
    de: {
        TODAY_STRING: "Heute",
        WEEKDAYS: [
            "MO",
            "DI",
            "MI",
            "DO",
            "FR",
            "SA",
            "SO"
        ],
        LEGENDS: {
            today: "Heute",
            fullClosed: "Voll / Geschlossen",
            available: "Verf\xfcgbar",
            offSeason: "Nebensaison"
        },
        PASSENGERS: {
            modalTitle: "Anzahl der Passagiere",
            modalText: `Um Ihnen unsere Flugverf\xfcgbarkeit basierend auf der Anzahl der Passagiere anbieten zu k\xf6nnen, teilen Sie uns bitte die Anzahl der Passagiere mit, die an diesem Flug teilnehmen werden.`,
            save: "Speichern",
            alert: {
                heading: "Nombre incorrect",
                content: `Die Anzahl der Passagiere muss zwischen 1 und ` + $474c9034caa9e90d$var$maximumPassengers + ` liegen.`,
                complement: `Wenn Sie mehr als ` + $474c9034caa9e90d$var$maximumPassengers + ` Pl\xe4tze reservieren m\xf6chten, k\xf6nnen Sie mehrere Reservierungen erstellen.`
            }
        },
        SLOTS: {
            flightType: {
                mountainFlight: "Morgenflug",
                mountainFlightDescription: "Berge",
                lowlandFlight: "Abendlicher Flug",
                lowlandFlightDescription: "Mittelland"
            },
            book: "Reservieren",
            remainingPlaces: "Pl\xe4tze",
            remainingPlace: "Platz"
        },
        DISCOUNT_VOUCHER: {
            label: "Discount Voucher",
            placeholder: "Gutschein Nr.",
            remainingAmount: `Der Restbetrag auf Ihrem Gutschein wird %s betragen.`
        },
        ORDER_SUMMARY: {
            title: "Ihre Bestell\xfcbersicht",
            alert: `Bitte w\xe4hlen Sie einen Flug aus dem Kalender aus.`,
            adultFlight: `Erwachsener Passagierflug`,
            childFlight: `Kind Passagierflug`,
            promoCodeDiscount: "Rabatt Aktionscode"
        },
        PROMO_CODE: {
            label: "Aktionscode",
            placeholder: "AKTIONSCODE",
            verifying: "Wird gepr\xfcft\u2026",
            applied: "Aktionscode angewendet.",
            invalid: "Dieser Aktionscode ist ung\xfcltig.",
            networkError: "Der Code konnte nicht gepr\xfcft werden. Bitte erneut versuchen.",
            fapdeNeedChild: "Dieser Aktionscode erfordert mindestens einen Kind-Passagier.",
            fapdeNeedAdult: "Dieser Aktionscode erfordert mindestens einen Erwachsenen-Passagier.",
            inactive: "Dieser Aktionscode existiert, ist aber noch nicht aktiviert."
        }
    }
};
module.exports = $474c9034caa9e90d$var$translations[$474c9034caa9e90d$var$language];

});

parcelRegister("eON6H", function(module, exports) {
module.exports = {
    fetchData: async ()=>{
        const quickReleaseData = fetch("/get-quick-release-data").then((response)=>response.json()).catch((error)=>{
            console.error(error);
        });
        return quickReleaseData;
    }
};

});

parcelRegister("chbRA", function(module, exports) {

var $kHnz7 = parcelRequire("kHnz7");

var $4eM2B = parcelRequire("4eM2B");
const $8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT = document.getElementById("booking-form");
let $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS = 1;
const $8f0046657a8c7a4c$var$validateBookingForm = (event)=>{
    event.preventDefault();
    event.stopPropagation();
    let isValid = true;
    if ($8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT.checkValidity() === false) {
        const flightDateInput = document.getElementById("booking-form-flightDate");
        const flightHourInput = document.getElementById("booking-form-flightHour");
        const flightTypeInput = document.getElementById("booking-form-flightType");
        if (flightDateInput.value !== "") {
            flightDateInput.classList.remove("is-invalid");
            flightDateInput.classList.add("is-valid");
        } else {
            flightDateInput.classList.remove("is-valid");
            flightDateInput.classList.add("is-invalid");
            isValid = false;
        }
        if (flightHourInput.value !== "") {
            flightHourInput.classList.remove("is-invalid");
            flightHourInput.classList.add("is-valid");
        } else {
            flightHourInput.classList.remove("is-valid");
            flightHourInput.classList.add("is-invalid");
            isValid = false;
        }
        if (flightTypeInput.value !== "") {
            flightTypeInput.classList.remove("is-invalid");
            flightTypeInput.classList.add("is-valid");
        } else {
            flightTypeInput.classList.remove("is-valid");
            flightTypeInput.classList.add("is-invalid");
            isValid = false;
        }
    }
    const phoneInput = document.getElementById("booking-form-phone");
    const emailInput = document.getElementById("booking-form-email");
    if (phoneInput.value !== "") {
        const phoneRegex = /^\+[1-9](?:\s?\d){10,}$/;
        if (!phoneRegex.test(phoneInput.value.trim())) {
            phoneInput.classList.remove("is-valid");
            phoneInput.classList.add("is-invalid");
            isValid = false;
        } else {
            phoneInput.classList.remove("is-invalid");
            phoneInput.classList.add("is-valid");
        }
    } else {
        phoneInput.classList.remove("is-valid");
        phoneInput.classList.add("is-invalid");
        isValid = false;
    }
    if (emailInput.value !== "") {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(emailInput.value.trim())) {
            emailInput.classList.remove("is-valid");
            emailInput.classList.add("is-invalid");
            isValid = false;
        } else {
            emailInput.classList.remove("is-invalid");
            emailInput.classList.add("is-valid");
        }
    }
    $8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT.classList.add("was-validated");
    if (isValid && $8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT.checkValidity() === true) event.target.submit();
    else $8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT.scrollIntoView();
};

const $8f0046657a8c7a4c$var$createAddPassengerButton = ()=>{
    const maximumPassengers = parseInt(document.getElementById("maximum-passengers").dataset.maximumPassengers);
    let freeCapacity = $4eM2B.existingReservation ? $4eM2B.reservation.flightData.freeCapacity - $4eM2B.reservation.flightData.toConfirmPassengers : JSON.parse(document.getElementById("booking-form-flightData").value).freeCapacity - JSON.parse(document.getElementById("booking-form-flightData").value).toConfirmPassengers;
    $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS = $4eM2B.existingReservation ? $4eM2B.reservation.numberOfPassengers : parseInt(document.getElementById("booking-form-numberOfPassengers").value);
    if (freeCapacity >= $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS + 1 && !document.querySelector(".add-passenger")) {
        const passengerButton = document.createElement("div");
        passengerButton.classList.add("add-passenger");
        const passengerFieldset = $8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT.querySelector("#booking-form-passengersInformation");
        passengerFieldset.appendChild(passengerButton);
        const numberOfPassengersInput = document.getElementById("booking-form-numberOfPassengers");
        passengerButton.addEventListener("click", ()=>{
            freeCapacity = JSON.parse(document.getElementById("booking-form-flightData").value).freeCapacity - JSON.parse(document.getElementById("booking-form-flightData").value).toConfirmPassengers;
            $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS = parseInt(document.getElementById("booking-form-numberOfPassengers").value);
            $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS += 1;
            numberOfPassengersInput.value = $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS;
            document.getElementById("number-of-passengers-value").innerHTML = $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS;
            $8f0046657a8c7a4c$var$updatePassengersInformationsField($8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS * 3, "addPassengerButton");
            $kHnz7.updateOrderSummaryTable();
            if ($8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS >= freeCapacity || $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS >= maximumPassengers) passengerButton.remove();
            const calendar = (parcelRequire("79tbc"));
            calendar.updateQuickReleaseData();
        });
    }
};
const $8f0046657a8c7a4c$var$removeAddPassengerButton = ()=>{
    const addPassengerButton = document.querySelector(".add-passenger");
    if (addPassengerButton) addPassengerButton.remove();
};
const $8f0046657a8c7a4c$var$updatePassengersInformationsField = (nbItemsToShow, clickedPassengerId)=>{
    const passengersInformationFieldset = $8f0046657a8c7a4c$var$BOOKING_FORM_ELEMENT.querySelector("#booking-form-passengersInformation");
    const passengersInformation = [];
    if ($4eM2B.existingReservation && clickedPassengerId === undefined) JSON.parse($4eM2B.reservation.passengersInformation).forEach((passenger, index)=>{
        const passengerNumber = index + 1;
        const passengerNameInput = passengersInformationFieldset.querySelector(`#booking-form-passenger${passengerNumber}Name`);
        const passengerWeightInput = passengersInformationFieldset.querySelector(`#booking-form-passenger${passengerNumber}Weight`);
        const passengerIsChildInput = passengersInformationFieldset.querySelector(`#booking-form-passenger${passengerNumber}IsChild`);
        passengerNameInput.value = passenger.name;
        passengerWeightInput.value = passenger.weight;
        passenger.isChild === "1" ? passengerIsChildInput.checked = true : passengerIsChildInput.checked = false;
    });
    else if (clickedPassengerId) {
        let count = 0;
        let passengerId = 0;
        let passengerData = [];
        // store passengers information into an array
        passengersInformationFieldset.querySelectorAll(".clearfix").forEach((formElement)=>{
            if (!formElement.classList.contains("hidden")) switch(count % 3){
                case 0:
                    passengerData = [];
                    passengerId++;
                    passengerData["name"] = formElement.querySelector(".form-control").value;
                    break;
                case 1:
                    passengerData["weight"] = formElement.querySelector(".form-control").value;
                    break;
                case 2:
                    passengerData["isChild"] = !!formElement.querySelector(".form-check-input").checked;
                    break;
            }
            else return false;
            if (count !== 0 && count % 3 === 2 && passengerId !== clickedPassengerId) passengersInformation.push(passengerData);
            count++;
        });
    }
    // hide all passengers fields and remove values
    passengersInformationFieldset.querySelectorAll(".clearfix").forEach((formElement)=>{
        formElement.classList.add("hidden");
        const formControl = formElement.querySelector(".form-control");
        if (formControl) {
            formControl.removeAttribute("required");
            formControl.value = "";
        } else if (formElement.querySelector(".form-check-input")) formElement.querySelector(".form-check-input").checked = false;
    });
    // show passengers fields regarding the number of passengers
    let count = 0;
    passengersInformationFieldset.querySelectorAll(".clearfix").forEach((formElement)=>{
        if (count < nbItemsToShow) {
            formElement.classList.remove("hidden");
            if (formElement.classList.contains("is-child-checkbox") && count <= nbItemsToShow && nbItemsToShow > 3) // show remove passenger button after is child checkbox
            $8f0046657a8c7a4c$var$addRemovePassengerButton(formElement, Math.floor(count / 3) + 1);
            else if (formElement.classList.contains("is-child-checkbox") && formElement.classList.contains("show-remove-passenger")) {
                formElement.classList.remove("show-remove-passenger");
                formElement.querySelector(".remove-passenger").remove();
            }
            // set form control as required
            var formControl = formElement.querySelector(".form-control");
            if (formControl) formControl.setAttribute("required", "true");
            const passengerId = Math.floor(count / 3);
            // set form control value
            if (Object.keys(passengersInformation).length && passengersInformation[passengerId]) switch(count % 3){
                case 0:
                    formElement.querySelector(".form-control").value = passengersInformation[passengerId].name;
                    break;
                case 1:
                    formElement.querySelector(".form-control").value = passengersInformation[passengerId].weight;
                    break;
                case 2:
                    formElement.querySelector(".form-check-input").checked = passengersInformation[passengerId].isChild;
                    break;
            }
        } else return false;
        count++;
    });
};

const $8f0046657a8c7a4c$var$addRemovePassengerButton = (formElement, passengerId)=>{
    if (formElement.querySelector(".remove-passenger") === null) {
        const removePassengerButton = document.createElement("div");
        removePassengerButton.classList.add("remove-passenger");
        formElement.appendChild(removePassengerButton);
        formElement.classList.add("show-remove-passenger");
        removePassengerButton.addEventListener("click", ()=>{
            $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS -= 1;
            document.getElementById("booking-form-numberOfPassengers").value = $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS;
            document.getElementById("number-of-passengers-value").innerHTML = $8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS;
            $8f0046657a8c7a4c$var$updatePassengersInformationsField($8f0046657a8c7a4c$var$NUMBER_OF_PASSENGERS * 3, passengerId);
            $kHnz7.updateOrderSummaryTable();
            if (!document.querySelector(".add-passenger")) $8f0046657a8c7a4c$var$createAddPassengerButton();
            const calendar = (parcelRequire("79tbc"));
            calendar.updateQuickReleaseData();
            calendar.updateCalendar();
        });
    }
};
const $8f0046657a8c7a4c$var$fillSubscriberInformation = ()=>{
    document.getElementById("booking-form-title").value = $4eM2B.reservation.subscriber.title;
    document.getElementById("booking-form-firstName").value = $4eM2B.reservation.subscriber.firstName;
    document.getElementById("booking-form-lastName").value = $4eM2B.reservation.subscriber.lastName;
    document.getElementById("booking-form-address").value = $4eM2B.reservation.subscriber.address;
    document.getElementById("booking-form-postalCode").value = $4eM2B.reservation.subscriber.postalCode;
    document.getElementById("booking-form-city").value = $4eM2B.reservation.subscriber.city;
    document.getElementById("booking-form-phone").value = $4eM2B.reservation.subscriber.phone;
    document.getElementById("booking-form-email").value = $4eM2B.reservation.subscriber.email;
    document.getElementById("booking-form-numberOfPassengers").value = $4eM2B.reservation.numberOfPassengers;
};
module.exports = {
    validateBookingForm: $8f0046657a8c7a4c$var$validateBookingForm,
    updatePassengersInformationsField: $8f0046657a8c7a4c$var$updatePassengersInformationsField,
    createAddPassengerButton: $8f0046657a8c7a4c$var$createAddPassengerButton,
    removeAddPassengerButton: $8f0046657a8c7a4c$var$removeAddPassengerButton,
    fillSubscriberInformation: $8f0046657a8c7a4c$var$fillSubscriberInformation
};

});
parcelRegister("kHnz7", function(module, exports) {

var $67wrA = parcelRequire("67wrA");

var $4eM2B = parcelRequire("4eM2B");
let $f11a1a6143938596$var$ORDER_SUMMARY_TABLE = null;
const $f11a1a6143938596$var$PRICES = JSON.parse(document.getElementById("prices-data").dataset.prices);
let $f11a1a6143938596$var$TOTAL_AMOUNT = 0.00;
let $f11a1a6143938596$var$TOTAL_AMOUNT_NO_DISCOUNT = 0.00;
/** Montant dû après bon cadeau, avant remise code promo (base pour l’API promo et l’affichage). */ let $f11a1a6143938596$var$AMOUNT_AFTER_GIFT_BEFORE_PROMO = 0.00;
const $f11a1a6143938596$var$buildOrderSummaryTable = ()=>{
    const orderSummary = document.createElement("div");
    orderSummary.classList.add("tc-website-ordersummary");
    const orderSummaryTitle = document.createElement("h3");
    orderSummaryTitle.classList.add("order-summary-title");
    orderSummaryTitle.innerText = $67wrA.ORDER_SUMMARY.title;
    const orderSummaryAlert = document.createElement("div");
    orderSummaryAlert.classList.add("order-summary-alert", "visible");
    orderSummaryAlert.innerHTML = $67wrA.ORDER_SUMMARY.alert;
    const orderSummaryTable = document.createElement("table");
    orderSummaryTable.classList.add("table", "table-borderless", "order-summary-table", "hidden");
    orderSummaryTable.innerHTML = `
        <tbody>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="2">Total:</td>
                <td class="total"></td>
            </tr>
        </tfoot>
    `;
    orderSummary.appendChild(orderSummaryTitle);
    orderSummary.appendChild(orderSummaryAlert);
    orderSummary.appendChild(orderSummaryTable);
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE = orderSummaryTable;
    document.querySelectorAll(".clearfix.is-child-checkbox").forEach((childCheckbox)=>{
        childCheckbox.addEventListener("change", ()=>{
            $f11a1a6143938596$var$updateOrderSummaryTable();
        });
    });
    return orderSummary;
};
const $f11a1a6143938596$var$updateOrderSummaryTable = (regionID = null)=>{
    if (regionID === null && document.getElementById("booking-form-flightData").value) {
        const flightData = JSON.parse(document.getElementById("booking-form-flightData").value);
        if (flightData["region"] !== undefined) regionID = flightData["region"];
    }
    if (regionID) {
        let totalAmount = 0.00;
        let areaData = [];
        $f11a1a6143938596$var$PRICES["areas"].forEach((area)=>{
            if (area.id === regionID) areaData = area;
        });
        let passengers = {
            adult: {
                count: 0,
                price: 0.00
            },
            child: {
                count: 0,
                price: 0.00
            }
        };
        let nbPassengers = 0;
        document.getElementById("booking-form-passengersInformation").querySelectorAll(".is-child-checkbox:not(.hidden)").forEach((childCheckboxContainer)=>{
            nbPassengers++;
            let passengerType = "";
            const checkbox = childCheckboxContainer.querySelector(".form-check-input");
            checkbox.checked ? passengerType = "child" : passengerType = "adult";
            passengers[passengerType]["count"]++;
            if (!areaData["prices"][passengerType]["preferentialRates"]) {
                totalAmount += areaData["prices"][passengerType]["price"];
                passengers[passengerType]["price"] += areaData["prices"][passengerType]["price"];
            }
        });
        if (areaData["prices"]["adult"]["preferentialRates"] && passengers.adult.count !== 0) {
            const adultsAmount = $f11a1a6143938596$var$getPreferentialAmount(areaData, "adult", passengers.adult.count);
            totalAmount += adultsAmount;
            passengers.adult.price += adultsAmount;
        }
        if (areaData["prices"]["child"]["preferentialRates"] && passengers.child.count !== 0) {
            const childrenAmount = $f11a1a6143938596$var$getPreferentialAmount(areaData, "child", passengers.child.count);
            totalAmount += childrenAmount;
            passengers.child.price += childrenAmount;
        }
        if (!$f11a1a6143938596$var$ORDER_SUMMARY_TABLE) $f11a1a6143938596$var$buildOrderSummaryTable();
        const discountRow = $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector(".discount-row");
        let availableAmount = null;
        if (discountRow) availableAmount = parseFloat(discountRow.dataset.availableAmount);
        else if (document.getElementById("gift-voucher-code-length") && $4eM2B.existingReservation && $4eM2B.reservation.giftVoucherAmount) availableAmount = parseFloat($4eM2B.reservation.giftVoucherAmount);
        $f11a1a6143938596$var$removeAllEntries();
        if (passengers.adult.count > 0) {
            const adultEntry = $f11a1a6143938596$var$createNewEntry(passengers.adult.count, "adult", passengers.adult.price);
            $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector("tbody").appendChild(adultEntry);
        }
        if (passengers.child.count > 0) {
            const childEntry = $f11a1a6143938596$var$createNewEntry(passengers.child.count, "child", passengers.child.price);
            $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector("tbody").appendChild(childEntry);
        }
        $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector(".total").innerText = $f11a1a6143938596$var$formatNumber(totalAmount);
        $f11a1a6143938596$var$TOTAL_AMOUNT = $f11a1a6143938596$var$TOTAL_AMOUNT_NO_DISCOUNT = totalAmount;
        if (availableAmount) $f11a1a6143938596$var$addGiftVoucherDiscount(availableAmount);
        $f11a1a6143938596$var$AMOUNT_AFTER_GIFT_BEFORE_PROMO = $f11a1a6143938596$var$TOTAL_AMOUNT;
        document.dispatchEvent(new CustomEvent("tcwebsite:orderSummaryUpdated", {
            bubbles: true
        }));
    }
};
const $f11a1a6143938596$var$addGiftVoucherDiscount = (amount)=>{
    let discount = amount * -1;
    if (amount > $f11a1a6143938596$var$TOTAL_AMOUNT_NO_DISCOUNT) {
        discount = $f11a1a6143938596$var$TOTAL_AMOUNT_NO_DISCOUNT * -1;
        $f11a1a6143938596$var$addGiftVoucherRemainingAmount(amount - $f11a1a6143938596$var$TOTAL_AMOUNT_NO_DISCOUNT);
    } else $f11a1a6143938596$var$removeGiftVoucherRemainingAmount();
    const discountEntry = document.createElement("tr");
    discountEntry.dataset.availableAmount = amount;
    discountEntry.classList = "discount-row";
    discountEntry.innerHTML = `
        <td></td>
        <td>Bon de r\xe9duction</td>
        <td class="price">` + $f11a1a6143938596$var$formatNumber(discount) + `</td>
    `;
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector("tbody").appendChild(discountEntry);
    $f11a1a6143938596$var$TOTAL_AMOUNT += discount;
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector(".total").innerText = $f11a1a6143938596$var$formatNumber($f11a1a6143938596$var$TOTAL_AMOUNT);
};
const $f11a1a6143938596$var$addGiftVoucherRemainingAmount = (remainingAmount)=>{
    $f11a1a6143938596$var$removeGiftVoucherRemainingAmount();
    const remainingAmountElement = document.createElement("i");
    remainingAmountElement.classList.add("remaining-amount");
    remainingAmountElement.innerText = $67wrA.DISCOUNT_VOUCHER.remainingAmount.replace("%s", $f11a1a6143938596$var$formatNumber(remainingAmount));
    document.querySelector(".tc-website-ordersummary").appendChild(remainingAmountElement);
};
const $f11a1a6143938596$var$removeGiftVoucherDiscount = ()=>{
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelectorAll(".discount-row").forEach((discountRow)=>{
        $f11a1a6143938596$var$TOTAL_AMOUNT -= parseFloat(discountRow.querySelector(".price").innerText);
        $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector(".total").innerText = $f11a1a6143938596$var$formatNumber($f11a1a6143938596$var$TOTAL_AMOUNT);
        discountRow.remove();
    });
    $f11a1a6143938596$var$removeGiftVoucherRemainingAmount();
};
const $f11a1a6143938596$var$removeGiftVoucherRemainingAmount = ()=>{
    document.querySelectorAll(".tc-website-ordersummary > .remaining-amount").forEach((item)=>{
        item.remove();
    });
};
const $f11a1a6143938596$var$removePromoDiscountRow = ()=>{
    if (!$f11a1a6143938596$var$ORDER_SUMMARY_TABLE) return;
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelectorAll(".promo-discount-row").forEach((row)=>{
        row.remove();
    });
    $f11a1a6143938596$var$TOTAL_AMOUNT = $f11a1a6143938596$var$AMOUNT_AFTER_GIFT_BEFORE_PROMO;
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector(".total").innerText = $f11a1a6143938596$var$formatNumber($f11a1a6143938596$var$TOTAL_AMOUNT);
};
/**
 * @param {number} discountPositive remise CHF (positive) renvoyée par l’API
 * @param {?number} totalAfterPromo total TTC calculé côté serveur (optionnel)
 */ const $f11a1a6143938596$var$addPromoDiscountRow = (discountPositive, totalAfterPromo = null)=>{
    if (!$f11a1a6143938596$var$ORDER_SUMMARY_TABLE || discountPositive <= 0) return;
    $f11a1a6143938596$var$removePromoDiscountRow();
    const discount = Math.min($f11a1a6143938596$var$AMOUNT_AFTER_GIFT_BEFORE_PROMO, discountPositive) * -1;
    const discountEntry = document.createElement("tr");
    discountEntry.classList.add("promo-discount-row");
    discountEntry.innerHTML = `
        <td></td>
        <td>` + $67wrA.ORDER_SUMMARY.promoCodeDiscount + `</td>
        <td class="price">` + $f11a1a6143938596$var$formatNumber(discount) + `</td>
    `;
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector("tbody").appendChild(discountEntry);
    const hasServerTotal = Number.isFinite(totalAfterPromo);
    $f11a1a6143938596$var$TOTAL_AMOUNT = hasServerTotal ? totalAfterPromo : $f11a1a6143938596$var$AMOUNT_AFTER_GIFT_BEFORE_PROMO + discount;
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector(".total").innerText = $f11a1a6143938596$var$formatNumber($f11a1a6143938596$var$TOTAL_AMOUNT);
};
const $f11a1a6143938596$var$getAmountForPromoValidation = ()=>$f11a1a6143938596$var$AMOUNT_AFTER_GIFT_BEFORE_PROMO;
/**
 * Compteurs + prix unitaires enfants pour l’API promo FAPDE (aligné sur le résumé commande).
 * @returns {{ adultCount: number, childAmounts: number[] }}
 */ const $f11a1a6143938596$var$getPromoPassengerPayload = ()=>{
    let regionID = null;
    if (document.getElementById("booking-form-flightData") && document.getElementById("booking-form-flightData").value) try {
        const flightData = JSON.parse(document.getElementById("booking-form-flightData").value);
        if (flightData["region"] !== undefined) regionID = flightData["region"];
    } catch (e) {
        regionID = null;
    }
    let adultCount = 0;
    let childCount = 0;
    const fieldset = document.getElementById("booking-form-passengersInformation");
    if (fieldset) fieldset.querySelectorAll(".is-child-checkbox:not(.hidden)").forEach((childCheckboxContainer)=>{
        const checkbox = childCheckboxContainer.querySelector(".form-check-input");
        if (checkbox && checkbox.checked) childCount++;
        else adultCount++;
    });
    const childAmounts = [];
    if (!regionID || childCount === 0) return {
        adultCount: adultCount,
        childAmounts: childAmounts
    };
    let areaData = null;
    $f11a1a6143938596$var$PRICES["areas"].forEach((area)=>{
        if (area.id === regionID) areaData = area;
    });
    if (!areaData) return {
        adultCount: adultCount,
        childAmounts: childAmounts
    };
    // Prix unitaire enfant (identique pour chaque enfant, y compris tarifs préférentiels)
    let unitChild = areaData["prices"]["child"]["price"];
    if (areaData["prices"]["child"]["preferentialRates"]) {
        const childrenTotal = $f11a1a6143938596$var$getPreferentialAmount(areaData, "child", childCount);
        unitChild = childCount > 0 ? childrenTotal / childCount : 0;
    }
    for(let i = 0; i < childCount; i++)childAmounts.push(Math.round(unitChild * 100) / 100);
    return {
        adultCount: adultCount,
        childAmounts: childAmounts
    };
};
const $f11a1a6143938596$var$getPreferentialAmount = (areaData, passengerType, nbPassengers)=>{
    let amount = 0.00;
    const preferentialRates = areaData["prices"][passengerType]["preferentialRates"];
    const reduction = preferentialRates["reduction"];
    const from = preferentialRates["from"];
    const to = preferentialRates["to"];
    const price = areaData["prices"][passengerType]["price"];
    if (nbPassengers >= from && nbPassengers <= to) amount = (price - reduction * (nbPassengers - 1)) * nbPassengers;
    else if (nbPassengers > to) amount = (price - reduction * (to - 1)) * nbPassengers;
    else if (nbPassengers < from) amount = price * nbPassengers;
    return amount;
};
const $f11a1a6143938596$var$createNewEntry = (nbPassengers, passengerType, amount)=>{
    const flightText = passengerType === "adult" ? $67wrA.ORDER_SUMMARY.adultFlight : $67wrA.ORDER_SUMMARY.childFlight;
    const newEntry = document.createElement("tr");
    newEntry.innerHTML = `
        <td>` + nbPassengers + `</td>
        <td>` + flightText + `</td>
        <td class="price">` + $f11a1a6143938596$var$formatNumber(amount) + `</td>
    `;
    return newEntry;
};
const $f11a1a6143938596$var$removeAllEntries = ()=>{
    $f11a1a6143938596$var$ORDER_SUMMARY_TABLE.querySelector("tbody").innerHTML = "";
};
const $f11a1a6143938596$var$formatNumber = (number)=>{
    return Intl.NumberFormat("fr-CH", {
        style: "currency",
        currency: "CHF"
    }).format(number);
};
module.exports = {
    buildOrderSummaryTable: $f11a1a6143938596$var$buildOrderSummaryTable,
    updateOrderSummaryTable: $f11a1a6143938596$var$updateOrderSummaryTable,
    addGiftVoucherDiscount: $f11a1a6143938596$var$addGiftVoucherDiscount,
    removeGiftVoucherDiscount: $f11a1a6143938596$var$removeGiftVoucherDiscount,
    addPromoDiscountRow: $f11a1a6143938596$var$addPromoDiscountRow,
    removePromoDiscountRow: $f11a1a6143938596$var$removePromoDiscountRow,
    getAmountForPromoValidation: $f11a1a6143938596$var$getAmountForPromoValidation,
    getPromoPassengerPayload: $f11a1a6143938596$var$getPromoPassengerPayload,
    /** Total affiché courant (après gift/promo) — smoke verify. */ getCurrentTotal: ()=>$f11a1a6143938596$var$TOTAL_AMOUNT
};

});
parcelRegister("4eM2B", function(module, exports) {
const $315dbc24fdcb29cb$var$existingReservation = document.getElementById("balloon-flight-booking-app").dataset.existingReservation === "1" || sessionStorage.getItem("reservation") !== null;
const $315dbc24fdcb29cb$var$reservation = document.getElementById("balloon-flight-booking-app").dataset.reservation ? JSON.parse(document.getElementById("balloon-flight-booking-app").dataset.reservation) : JSON.parse(sessionStorage.getItem("reservation"));
module.exports = {
    existingReservation: $315dbc24fdcb29cb$var$existingReservation,
    reservation: $315dbc24fdcb29cb$var$reservation
};

});



parcelRegister("4MScu", function(module, exports) {

var $i5n9Y = parcelRequire("i5n9Y");

var $5731O = parcelRequire("5731O");

var $kHnz7 = parcelRequire("kHnz7");
const $37c5b02c4b12ca94$var$resolveBuilder = (moduleRef, namedExport)=>{
    if (moduleRef && typeof moduleRef[namedExport] === "function") return moduleRef[namedExport];
    if (moduleRef && moduleRef.default && typeof moduleRef.default[namedExport] === "function") return moduleRef.default[namedExport];
    if (moduleRef && typeof moduleRef.default === "function") return moduleRef.default;
    if (typeof moduleRef === "function") return moduleRef;
    return null;
};
/**
 * Point d’ancrage du panier (bon + code promo + résumé) dans le formulaire Neos.
 * L’id attendu est #booking-form-flightInformation ; en secours, le fieldset parent
 * du champ date de vol (certaines versions / rendus du Form Builder).
 */ const $37c5b02c4b12ca94$var$resolveFlightInformationMount = ()=>{
    const byId = document.getElementById("booking-form-flightInformation");
    if (byId) return byId;
    const bySuffix = document.querySelector('fieldset[id$="-flightInformation"]');
    if (bySuffix) return bySuffix;
    const flightDate = document.getElementById("booking-form-flightDate");
    if (flightDate) {
        const withId = flightDate.closest("fieldset[id]");
        if (withId) return withId;
        return flightDate.closest("fieldset");
    }
    const flightType = document.getElementById("booking-form-flightType");
    if (flightType) return flightType.closest("fieldset[id]") || flightType.closest("fieldset");
    return null;
};
/**
 * Insère une seule fois le bloc panier sous « Détails du vol ».
 * Doit fonctionner pour une nouvelle réservation et lorsqu’un reste de session
 * (`sessionStorage.reservation`) fait passer `existingReservation` à true par erreur.
 */ const $37c5b02c4b12ca94$var$mountBookingBasketIfNeeded = ()=>{
    if (document.querySelector(".tc-website-basket")) return true;
    const mount = $37c5b02c4b12ca94$var$resolveFlightInformationMount();
    if (!mount) {
        console.warn("[TC.Website] Impossible de monter le panier : section \xab D\xe9tails du vol \xbb introuvable.");
        return false;
    }
    const giftVoucherSettingsEl = document.getElementById("gift-voucher-code-length");
    const buildDiscountVoucherField = $37c5b02c4b12ca94$var$resolveBuilder($i5n9Y, "buildDiscountVoucherField");
    const buildPromoCodeField = $37c5b02c4b12ca94$var$resolveBuilder($5731O, "buildPromoCodeField");
    if (giftVoucherSettingsEl && !buildDiscountVoucherField) {
        console.error("[TC.Website] buildDiscountVoucherField indisponible.");
        return false;
    }
    const discountVoucherField = giftVoucherSettingsEl && buildDiscountVoucherField ? buildDiscountVoucherField() : null;
    const promoField = buildPromoCodeField ? buildPromoCodeField() : null;
    const orderSummaryTable = $kHnz7.buildOrderSummaryTable();
    const basketWrapper = document.createElement("div");
    basketWrapper.classList.add("tc-website-basket", "clearfix");
    if (discountVoucherField) basketWrapper.appendChild(discountVoucherField);
    if (promoField) basketWrapper.appendChild(promoField);
    basketWrapper.appendChild(orderSummaryTable);
    mount.appendChild(basketWrapper);
    return true;
};
module.exports = {
    mountBookingBasketIfNeeded: $37c5b02c4b12ca94$var$mountBookingBasketIfNeeded,
    resolveFlightInformationMount: $37c5b02c4b12ca94$var$resolveFlightInformationMount
};

});
parcelRegister("i5n9Y", function(module, exports) {

var $67wrA = parcelRequire("67wrA");

var $kHnz7 = parcelRequire("kHnz7");

var $4eM2B = parcelRequire("4eM2B");

var $agPO5 = parcelRequire("agPO5");
var $d2aaa8b767e27522$require$shouldTriggerGiftVoucherVerifyWithConfig = $agPO5.shouldTriggerGiftVoucherVerifyWithConfig;
/** Longueur max du code (injectée par Neos). @returns {number|null} */ const $d2aaa8b767e27522$var$getCodeLength = ()=>{
    const raw = document.getElementById("gift-voucher-code-length")?.dataset.codeLength;
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
/**
 * Seuil pour déclencher verify (smoke : data-min-length, ex. 16 ; sinon codeLength bon).
 * @returns {number|null}
 */ const $d2aaa8b767e27522$var$getMinVerifyLength = ()=>{
    const el = document.getElementById("gift-voucher-code-length");
    const raw = el?.dataset.minLength || el?.dataset.codeLength;
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
/**
 * Préfixe des bons de test admin (Settings adminTestCodePrefix), ex. TEST-.
 * @returns {string|null}
 */ const $d2aaa8b767e27522$var$getTestCodePrefix = ()=>{
    const raw = document.getElementById("gift-voucher-code-length")?.dataset.testCodePrefix || "";
    const prefix = String(raw).trim().toUpperCase();
    return prefix !== "" ? prefix : null;
};
/**
 * Déclenche l’appel /verify-gift-voucher-code ? (lit data-* DOM).
 *
 * @param {string} rawValue
 * @returns {boolean}
 */ const $d2aaa8b767e27522$var$shouldTriggerGiftVoucherVerify = (rawValue)=>{
    return $d2aaa8b767e27522$require$shouldTriggerGiftVoucherVerifyWithConfig(rawValue, $d2aaa8b767e27522$var$getMinVerifyLength(), $d2aaa8b767e27522$var$getTestCodePrefix());
};
const $d2aaa8b767e27522$var$getHiddenGiftVoucherCodeInput = ()=>document.getElementById("booking-form-giftVoucherCode");
/**
 * Toujours synchroniser le champ visible → hidden (soumission serveur smoke/bon).
 * Particularité : ne pas vider le hidden tant que l’utilisateur tape (seuil verify).
 */ const $d2aaa8b767e27522$var$syncHiddenGiftVoucherCode = (visibleInput)=>{
    const hidden = $d2aaa8b767e27522$var$getHiddenGiftVoucherCodeInput();
    if (!hidden) return;
    const value = (visibleInput.value || "").trim();
    hidden.value = value;
};
const $d2aaa8b767e27522$var$buildDiscountVoucherField = ()=>{
    const codeLength = $d2aaa8b767e27522$var$getCodeLength();
    const hiddenGiftVoucherCodeInput = $d2aaa8b767e27522$var$getHiddenGiftVoucherCodeInput();
    const discountVoucherField = document.createElement("div");
    discountVoucherField.classList.add("tc-website-discountvoucher", "clearfix");
    const discountVoucherLabel = document.createElement("label");
    discountVoucherLabel.classList.add("form-label");
    discountVoucherLabel.setAttribute("for", "discount-voucher");
    discountVoucherLabel.innerHTML = $67wrA.DISCOUNT_VOUCHER.label;
    const discountVoucherInput = document.createElement("div");
    discountVoucherInput.classList.add("input");
    const discountVoucherInputField = document.createElement("input");
    discountVoucherInputField.classList.add("form-control");
    discountVoucherInputField.setAttribute("id", "discount-voucher");
    discountVoucherInputField.setAttribute("type", "text");
    discountVoucherInputField.setAttribute("placeholder", $67wrA.DISCOUNT_VOUCHER.placeholder);
    // Smoke : éviter uppercase CSS qui trompe la relecture (valeur reste telle quelle)
    discountVoucherInputField.setAttribute("autocapitalize", "off");
    discountVoucherInputField.setAttribute("spellcheck", "false");
    if (codeLength !== null) discountVoucherInputField.setAttribute("maxlength", String(codeLength));
    if ($4eM2B.existingReservation && $4eM2B.reservation.giftVoucherCode && hiddenGiftVoucherCodeInput) discountVoucherInputField.value = hiddenGiftVoucherCodeInput.value = $4eM2B.reservation.giftVoucherCode;
    discountVoucherInputField.addEventListener("input", ()=>{
        $d2aaa8b767e27522$var$checkVoucherCode(discountVoucherInputField);
    });
    const discountVoucherMessage = document.createElement("div");
    discountVoucherMessage.setAttribute("id", "discount-voucher-message");
    discountVoucherInput.appendChild(discountVoucherInputField);
    discountVoucherField.appendChild(discountVoucherLabel);
    discountVoucherField.appendChild(discountVoucherInput);
    discountVoucherField.appendChild(discountVoucherMessage);
    return discountVoucherField;
};
const $d2aaa8b767e27522$var$checkVoucherCode = (discountVoucherInputField)=>{
    const discountVoucherMessage = document.getElementById("discount-voucher-message");
    discountVoucherMessage.classList.remove("visible");
    // Toujours envoyer le code au serveur à la soumission (smoke virtuel)
    $d2aaa8b767e27522$var$syncHiddenGiftVoucherCode(discountVoucherInputField);
    if (!$d2aaa8b767e27522$var$shouldTriggerGiftVoucherVerify(discountVoucherInputField.value)) {
        discountVoucherInputField.setCustomValidity("");
        discountVoucherInputField.classList.remove("is-valid");
        discountVoucherInputField.classList.remove("is-invalid");
        if (document.querySelector(".tc-website-ordersummary")?.querySelector(".discount-row")) $kHnz7.removeGiftVoucherDiscount();
        return;
    }
    fetch("/verify-gift-voucher-code", {
        method: "POST",
        body: JSON.stringify({
            giftVoucherCode: discountVoucherInputField.value,
            locale: document.documentElement.getAttribute("lang"),
            // Smoke 6.7 : allowlist e-mail + total après promo pour forcer 1 CHF
            email: document.querySelector("#booking-form-email")?.value || document.querySelector('input[name*="[email]"]')?.value || "",
            currentTotal: $kHnz7.getCurrentTotal()
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    }).then((response)=>response.json()).then((response)=>{
        let hasDiscount = document.querySelector(".tc-website-ordersummary").querySelector(".discount-row");
        if (response.status === "valid") {
            discountVoucherInputField.setCustomValidity("");
            discountVoucherInputField.classList.remove("is-invalid");
            discountVoucherInputField.classList.add("is-valid");
            if (!hasDiscount) $kHnz7.addGiftVoucherDiscount(parseFloat(response.availableAmount));
            else {
                $kHnz7.removeGiftVoucherDiscount();
                $kHnz7.addGiftVoucherDiscount(parseFloat(response.availableAmount));
            }
            $d2aaa8b767e27522$var$syncHiddenGiftVoucherCode(discountVoucherInputField);
        } else {
            discountVoucherInputField.setCustomValidity("Invalid field.");
            discountVoucherInputField.classList.remove("is-valid");
            discountVoucherInputField.classList.add("is-invalid");
            if (hasDiscount) $kHnz7.removeGiftVoucherDiscount();
            // Garder le hidden synchronisé : le serveur tranche à la création
            $d2aaa8b767e27522$var$syncHiddenGiftVoucherCode(discountVoucherInputField);
            if (response.status === "used" || response.status === "invalid") {
                discountVoucherMessage.innerText = response.message;
                discountVoucherMessage.classList.add("visible");
            }
        }
    }).catch((error)=>{
        console.error(error);
    });
};
module.exports = {
    buildDiscountVoucherField: $d2aaa8b767e27522$var$buildDiscountVoucherField,
    shouldTriggerGiftVoucherVerify: $d2aaa8b767e27522$var$shouldTriggerGiftVoucherVerify,
    shouldTriggerGiftVoucherVerifyWithConfig: $d2aaa8b767e27522$require$shouldTriggerGiftVoucherVerifyWithConfig
};
module.exports.default = {
    buildDiscountVoucherField: $d2aaa8b767e27522$var$buildDiscountVoucherField,
    shouldTriggerGiftVoucherVerify: $d2aaa8b767e27522$var$shouldTriggerGiftVoucherVerify,
    shouldTriggerGiftVoucherVerifyWithConfig: $d2aaa8b767e27522$require$shouldTriggerGiftVoucherVerifyWithConfig
};

});
parcelRegister("agPO5", function(module, exports) {
/**
 * Seuil de vérification bon cadeau (logique pure, sans DOM).
 *
 * Particularité story 5.3 : les codes TEST-* admin sont plus courts que les bons
 * Payrexx (longueur ≈ codeLength + 8 + codeSplit). Dès qu’il y a un caractère
 * après le préfixe test, on déclenche /verify-gift-voucher-code.
 *
 * @param {string} rawValue
 * @param {number|null} minVerifyLength
 * @param {string|null} testPrefix
 * @returns {boolean}
 */ function $77a395c1ef1573d4$var$shouldTriggerGiftVoucherVerifyWithConfig(rawValue, minVerifyLength, testPrefix) {
    if (minVerifyLength === null || minVerifyLength === undefined) return false;
    if (!Number.isFinite(minVerifyLength) || minVerifyLength <= 0) return false;
    const value = String(rawValue || "").trim();
    if (value === "") return false;
    const prefix = testPrefix ? String(testPrefix).trim().toUpperCase() : "";
    if (prefix !== "" && value.toUpperCase().startsWith(prefix) && value.length > prefix.length) return true;
    return value.length >= minVerifyLength;
}
module.exports = {
    shouldTriggerGiftVoucherVerifyWithConfig: $77a395c1ef1573d4$var$shouldTriggerGiftVoucherVerifyWithConfig
};
module.exports.default = {
    shouldTriggerGiftVoucherVerifyWithConfig: $77a395c1ef1573d4$var$shouldTriggerGiftVoucherVerifyWithConfig
};

});


parcelRegister("5731O", function(module, exports) {

var $67wrA = parcelRequire("67wrA");

var $kHnz7 = parcelRequire("kHnz7");
const $3b8ff48a882f648e$var$PROMO_ENDPOINT_EL = document.getElementById("promo-code-endpoint");
const $3b8ff48a882f648e$var$MIN_CODE_LENGTH = 3;
let $3b8ff48a882f648e$var$summaryListenerAttached = false;
let $3b8ff48a882f648e$var$requestSeq = 0;
let $3b8ff48a882f648e$var$appliedNormalizedCode = "";
const $3b8ff48a882f648e$var$hiddenPromoInput = ()=>document.getElementById("booking-form-promoCode");
const $3b8ff48a882f648e$var$setMessage = (el, text, show)=>{
    el.innerText = text || "";
    if (show) el.classList.add("visible");
    else el.classList.remove("visible");
};
const $3b8ff48a882f648e$var$resetFieldValidationClasses = (input)=>{
    input.classList.remove("is-valid", "is-invalid", "is-loading");
    input.removeAttribute("aria-busy");
};
const $3b8ff48a882f648e$var$buildPromoCodeField = ()=>{
    if (!$3b8ff48a882f648e$var$PROMO_ENDPOINT_EL || !$3b8ff48a882f648e$var$PROMO_ENDPOINT_EL.dataset.url) return null;
    const maxLength = $3b8ff48a882f648e$var$PROMO_ENDPOINT_EL.dataset.maxLength || "64";
    const root = document.createElement("div");
    root.classList.add("tc-website-promocode", "clearfix");
    const label = document.createElement("label");
    label.classList.add("form-label");
    label.setAttribute("for", "promo-code");
    label.innerHTML = $67wrA.PROMO_CODE.label;
    const inputWrap = document.createElement("div");
    inputWrap.classList.add("input");
    const input = document.createElement("input");
    input.classList.add("form-control");
    input.setAttribute("id", "promo-code");
    input.setAttribute("type", "text");
    input.setAttribute("autocomplete", "off");
    input.setAttribute("placeholder", $67wrA.PROMO_CODE.placeholder);
    input.setAttribute("maxlength", maxLength);
    input.setAttribute("aria-describedby", "promo-code-message");
    const message = document.createElement("div");
    message.setAttribute("id", "promo-code-message");
    message.setAttribute("role", "status");
    message.setAttribute("aria-live", "polite");
    input.addEventListener("input", ()=>{
        const hid = $3b8ff48a882f648e$var$hiddenPromoInput();
        const norm = input.value.trim().toUpperCase();
        if ($3b8ff48a882f648e$var$appliedNormalizedCode && norm !== $3b8ff48a882f648e$var$appliedNormalizedCode) {
            $3b8ff48a882f648e$var$appliedNormalizedCode = "";
            $kHnz7.removePromoDiscountRow();
            if (hid) hid.value = "";
        }
        $3b8ff48a882f648e$var$resetFieldValidationClasses(input);
        $3b8ff48a882f648e$var$setMessage(message, "", false);
    });
    input.addEventListener("blur", ()=>{
        $3b8ff48a882f648e$var$runPromoValidation(input, message, false);
    });
    input.addEventListener("keydown", (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            $3b8ff48a882f648e$var$runPromoValidation(input, message, false);
        }
    });
    inputWrap.appendChild(input);
    root.appendChild(label);
    root.appendChild(inputWrap);
    root.appendChild(message);
    return root;
};
const $3b8ff48a882f648e$var$runPromoValidation = (input, messageEl, silent)=>{
    if (!$3b8ff48a882f648e$var$PROMO_ENDPOINT_EL || !$3b8ff48a882f648e$var$PROMO_ENDPOINT_EL.dataset.url) return;
    const raw = input.value.trim();
    const hid = $3b8ff48a882f648e$var$hiddenPromoInput();
    if (raw.length < $3b8ff48a882f648e$var$MIN_CODE_LENGTH) {
        $3b8ff48a882f648e$var$appliedNormalizedCode = "";
        $kHnz7.removePromoDiscountRow();
        if (hid) hid.value = "";
        $3b8ff48a882f648e$var$resetFieldValidationClasses(input);
        if (!silent) $3b8ff48a882f648e$var$setMessage(messageEl, "", false);
        return;
    }
    const totalBase = $kHnz7.getAmountForPromoValidation();
    if (totalBase <= 0) return;
    const pax = $kHnz7.getPromoPassengerPayload ? $kHnz7.getPromoPassengerPayload() : {
        adultCount: 0,
        childAmounts: []
    };
    const mySeq = ++$3b8ff48a882f648e$var$requestSeq;
    input.classList.add("is-loading");
    input.setAttribute("aria-busy", "true");
    if (!silent) $3b8ff48a882f648e$var$setMessage(messageEl, $67wrA.PROMO_CODE.verifying, true);
    fetch($3b8ff48a882f648e$var$PROMO_ENDPOINT_EL.dataset.url, {
        method: "POST",
        body: JSON.stringify({
            promoCode: raw,
            totalAmount: totalBase,
            adultCount: pax.adultCount,
            childAmounts: pax.childAmounts
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    }).then((response)=>response.json()).then((payload)=>{
        if (mySeq !== $3b8ff48a882f648e$var$requestSeq) return;
        input.classList.remove("is-loading");
        input.removeAttribute("aria-busy");
        if (payload.success === true && payload.data) {
            const discount = parseFloat(payload.data.discountAmount);
            const totalAfterPromo = parseFloat(payload.data.totalAmount);
            if (!(discount > 0)) {
                $3b8ff48a882f648e$var$handleFailure(input, messageEl, $67wrA.PROMO_CODE.invalid, hid);
                return;
            }
            // Afficher « appliqué » aussi en revalidation silencieuse après correction pax (ex. enfant coché)
            const showAppliedFeedback = !silent || input.classList.contains("is-invalid");
            $3b8ff48a882f648e$var$appliedNormalizedCode = String(payload.data.promoCode || raw).toUpperCase();
            input.classList.add("is-valid");
            input.classList.remove("is-invalid");
            if (showAppliedFeedback) $3b8ff48a882f648e$var$setMessage(messageEl, $67wrA.PROMO_CODE.applied, true);
            else $3b8ff48a882f648e$var$setMessage(messageEl, "", false);
            $kHnz7.removePromoDiscountRow();
            $kHnz7.addPromoDiscountRow(discount, totalAfterPromo);
            if (hid) hid.value = $3b8ff48a882f648e$var$appliedNormalizedCode;
            return;
        }
        const errCode = payload.error && payload.error.code ? payload.error.code : "";
        let errText = payload.error && payload.error.message ? payload.error.message : $67wrA.PROMO_CODE.invalid;
        if (errCode === "PROMO_FAPDE_NEED_CHILD" && $67wrA.PROMO_CODE.fapdeNeedChild) errText = $67wrA.PROMO_CODE.fapdeNeedChild;
        else if (errCode === "PROMO_FAPDE_NEED_ADULT" && $67wrA.PROMO_CODE.fapdeNeedAdult) errText = $67wrA.PROMO_CODE.fapdeNeedAdult;
        else if (errCode === "PROMO_INACTIVE" && $67wrA.PROMO_CODE.inactive) errText = $67wrA.PROMO_CODE.inactive;
        $3b8ff48a882f648e$var$handleFailure(input, messageEl, errText, hid);
    }).catch(()=>{
        if (mySeq !== $3b8ff48a882f648e$var$requestSeq) return;
        input.classList.remove("is-loading");
        input.removeAttribute("aria-busy");
        $3b8ff48a882f648e$var$handleFailure(input, messageEl, $67wrA.PROMO_CODE.networkError, hid);
    });
};
const $3b8ff48a882f648e$var$handleFailure = (input, messageEl, text, hid)=>{
    // Ne pas effacer le code saisi : on garde la valeur pour revalider après changement pax (FAPDE)
    $3b8ff48a882f648e$var$appliedNormalizedCode = "";
    input.classList.remove("is-valid", "is-loading");
    input.classList.add("is-invalid");
    $kHnz7.removePromoDiscountRow();
    if (hid) hid.value = "";
    $3b8ff48a882f648e$var$setMessage(messageEl, text, true);
};
const $3b8ff48a882f648e$var$initPromoCodeHook = ()=>{
    if (!$3b8ff48a882f648e$var$PROMO_ENDPOINT_EL || !$3b8ff48a882f648e$var$PROMO_ENDPOINT_EL.dataset.url) return null;
    if (!$3b8ff48a882f648e$var$summaryListenerAttached) {
        $3b8ff48a882f648e$var$summaryListenerAttached = true;
        // Dès que le résumé change (enfant coché, passager ajouté, etc.), revalider
        // si un code est encore saisi — y compris après un refus FAPDE (appliedNormalizedCode vide).
        document.addEventListener("tcwebsite:orderSummaryUpdated", ()=>{
            const input = document.getElementById("promo-code");
            const messageEl = document.getElementById("promo-code-message");
            if (!input || !messageEl) return;
            if (input.value.trim().length < $3b8ff48a882f648e$var$MIN_CODE_LENGTH) return;
            $3b8ff48a882f648e$var$runPromoValidation(input, messageEl, true);
        });
    }
    return {
        endpoint: $3b8ff48a882f648e$var$PROMO_ENDPOINT_EL.dataset.url
    };
};
module.exports = {
    buildPromoCodeField: $3b8ff48a882f648e$var$buildPromoCodeField,
    initPromoCodeHook: $3b8ff48a882f648e$var$initPromoCodeHook
};

});


parcelRegister("bJHsY", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("gngdn")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), i = {
        name: "fr",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        ordinal: function(e) {
            return "" + e + (1 === e ? "er" : "");
        }
    };
    return t.default.locale(i, null, !0), i;
});

});

parcelRegister("f2hMu", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(e) {
            var n = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (n[(t - 20) % 10] || n[t] || n[0]) + "]";
        }
    };
});

});

parcelRegister("gYC2S", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("gngdn")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), a = {
        s: "ein paar Sekunden",
        m: [
            "eine Minute",
            "einer Minute"
        ],
        mm: "%d Minuten",
        h: [
            "eine Stunde",
            "einer Stunde"
        ],
        hh: "%d Stunden",
        d: [
            "ein Tag",
            "einem Tag"
        ],
        dd: [
            "%d Tage",
            "%d Tagen"
        ],
        M: [
            "ein Monat",
            "einem Monat"
        ],
        MM: [
            "%d Monate",
            "%d Monaten"
        ],
        y: [
            "ein Jahr",
            "einem Jahr"
        ],
        yy: [
            "%d Jahre",
            "%d Jahren"
        ]
    };
    function i(e, n, t) {
        var i = a[t];
        return Array.isArray(i) && (i = i[n ? 0 : 1]), i.replace("%d", e);
    }
    var r = {
        name: "de",
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        yearStart: 4,
        formats: {
            LTS: "HH:mm:ss",
            LT: "HH:mm",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: i,
            m: i,
            mm: i,
            h: i,
            hh: i,
            d: i,
            dd: i,
            M: i,
            MM: i,
            y: i,
            yy: i
        }
    };
    return t.default.locale(r, null, !0), r;
});

});



var $gngdn = parcelRequire("gngdn");
var $a2bec1e4479b2feb$exports = {};
!function(e, t) {
    $a2bec1e4479b2feb$exports = t();
}($a2bec1e4479b2feb$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});


var $8e2e75cb547a7c44$exports = {};
!function(e, t) {
    $8e2e75cb547a7c44$exports = t();
}($8e2e75cb547a7c44$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $4e06fd583db725ab$exports = {};
!function(e, i) {
    $4e06fd583db725ab$exports = i();
}($4e06fd583db725ab$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});



var $79tbc = parcelRequire("79tbc");

var $chbRA = parcelRequire("chbRA");

var $5731O = parcelRequire("5731O");

var $4MScu = parcelRequire("4MScu");
parcelRequire("4eM2B");
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend($a2bec1e4479b2feb$exports);
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend($8e2e75cb547a7c44$exports);
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend($4e06fd583db725ab$exports);
const $35da740d59af89ba$var$CALENDAR_ELEMENT = $79tbc.buildCalendar("balloon-flight-booking-app");
$4MScu.mountBookingBasketIfNeeded();
$5731O.initPromoCodeHook();
$35da740d59af89ba$var$CALENDAR_ELEMENT.addEventListener("fetchData", (event)=>{
    $79tbc.updateNumberOfPassengers(event.detail.passengers);
    $79tbc.updateQuickReleaseData();
});
document.getElementById("booking-form").addEventListener("submit", (event)=>{
    $chbRA.validateBookingForm(event);
});


//# sourceMappingURL=index.1d830725.js.map
